import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appBlurOnEnter]',
  standalone: true
})
export class BlurOnEnterDirective {
  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent): void {
    (event.target as HTMLElement)?.blur();
  }
}
